import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { PdpSharedStorytellingShopAllLink } from './PdpSharedStorytellingShopAllLink';
import { PdpSharedStorytellingMainMedia_storyTellingTab } from './__generated__/PdpSharedStorytellingMainMedia_storyTellingTab.graphql';
import { getSrcsetString } from '../../utils/srcSet';

import styles from './PdpSharedStorytellingMainMedia.scss';

type Props = {
    storyTellingTab: PdpSharedStorytellingMainMedia_storyTellingTab;
};

const PdpSharedStorytellingMainMediaComponent: FC<Props> = ({ storyTellingTab }) => {
    const { mainImage, mainVideo, tabTitle } = storyTellingTab;
    const hasContent = mainImage || mainVideo;
    return hasContent ? (
        <div className={styles.mediaColumnWrapper}>
            {mainImage && (
                <img
                    className={styles.mainMedia}
                    src={mainImage}
                    srcSet={getSrcsetString(mainImage)}
                    sizes="(max-width: 568px) 100vw, (max-width: 768px) 50vw, 42vw"
                    alt=""
                />
            )}
            {mainVideo && (
                <iframe
                    title={tabTitle}
                    className={`${styles.mainMedia} ${styles.mainVideo}`}
                    src={mainVideo}
                    height="100%"
                    width="100%"
                    frameBorder="0"
                    allowFullScreen
                />
            )}

            <PdpSharedStorytellingShopAllLink storyTellingTab={storyTellingTab} />
        </div>
    ) : null;
};

export const PdpSharedStorytellingMainMedia = createFragmentContainer(
    PdpSharedStorytellingMainMediaComponent,
    {
        storyTellingTab: graphql`
            fragment PdpSharedStorytellingMainMedia_storyTellingTab on StoryTellingTab {
                tabTitle
                mainImage
                mainVideo
                ...PdpSharedStorytellingShopAllLink_storyTellingTab
            }
        `,
    }
);
